export function displayDocumentTitle(title: string): string {
  const trimmed = title.trim()
  return trimmed || 'Untitled'
}

export const DOCUMENT_QUERY_PARAM = 'document'

export function documentsUrlWithDocument(documentId: string): string {
  return `/documents?${DOCUMENT_QUERY_PARAM}=${encodeURIComponent(documentId)}`
}
